import { render, staticRenderFns } from "./convenios.vue?vue&type=template&id=1e91e3f2&scoped=true&"
import script from "./convenios.vue?vue&type=script&lang=js&"
export * from "./convenios.vue?vue&type=script&lang=js&"
import style0 from "./convenios.vue?vue&type=style&index=0&id=1e91e3f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e91e3f2",
  null
  
)

export default component.exports